// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2AW3x","title":"FrontImage_title__17O0y"};